import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import ThemeToggle from './components/ThemeToggle';
import SessionExpiryWarning from './components/SessionExpiryWarning';

import AdvisorLogin from './pages/advisor/AdvisorLogin';
import AdvisorSignup from './pages/advisor/AdvisorSignup';
import AdvisorDashboard from './pages/advisor/AdvisorDashboard';
import AdvisorPrefillForm from './pages/advisor/AdvisorPrefillForm';
import SubmissionView from './pages/advisor/SubmissionView';
import PasswordReset from './pages/advisor/PasswordReset';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdvisorDetail from './pages/admin/AdvisorDetail';
import CSADashboard from './pages/csa/CSADashboard';
import ClientVerification from './pages/client/ClientVerification';
import ClientForm from './pages/client/ClientForm';
import ThankYou from './pages/client/ThankYou';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/advisor/login" replace />} />
          
          {/* Advisor Routes */}
          <Route path="/advisor/login" element={<AdvisorLogin />} />
          <Route path="/advisor/signup" element={<AdvisorSignup />} />
          <Route path="/advisor/forgot-password" element={<PasswordReset />} />
          <Route path="/advisor/reset-password" element={<PasswordReset />} />
          <Route
            path="/advisor/dashboard"
            element={
              <ProtectedRoute>
                <AdvisorDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/advisor/submission/:submissionId"
            element={
              <ProtectedRoute>
                <SubmissionView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/advisor/invites/:inviteId/prefill"
            element={
              <ProtectedRoute>
                <AdvisorPrefillForm />
              </ProtectedRoute>
            }
          />
          
          {/* Admin Routes */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/advisors/:advisorId"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdvisorDetail />
              </ProtectedRoute>
            }
          />

          {/* CSA Routes */}
          <Route
            path="/csa/dashboard"
            element={
              <ProtectedRoute allowedRoles={['csa', 'admin']}>
                <CSADashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Client Routes */}
          <Route path="/f/:token" element={<ClientVerification />} />
          <Route path="/client/form/:inviteId" element={<ClientForm />} />
          <Route path="/client/thank-you" element={<ThankYou />} />
        </Routes>
        <Toaster position="top-right" richColors />
        <ThemeToggle />
        <SessionExpiryWarning />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
